document.addEventListener('DOMContentLoaded', function () {
      function stripRadiosInRoot(root) {
        if (!root) return;
        // Target both the part and the element itself, depending on how Recharge renders it
        const icons = root.querySelectorAll('rc-radio-icon, [part="rc-purchase-option__checked-indicator"]');
        icons.forEach(function (icon) {
          const sr = icon.shadowRoot || icon;
          const svg = sr.querySelector('svg');
          if (svg) {
            svg.remove();
          }
        });
      }
      function scanRechargeWidgets() {
        // Look for possible Recharge widget hosts in the main DOM
        const hosts = document.querySelectorAll(
          'recharge-subscription-widget, rc-widget, rc-inline, [data-rc-widget]'
        );
        if (hosts.length) {
          hosts.forEach(function (host) {
            if (host.shadowRoot) {
              // Clean inside the widget shadow root
              stripRadiosInRoot(host.shadowRoot);

              // Also scan any nested elements that themselves have shadow roots
              host.shadowRoot.querySelectorAll('*').forEach(function (el) {
                if (el.shadowRoot) {
                  stripRadiosInRoot(el.shadowRoot);
                }
              });
            } else {
              // Fallback if no shadowRoot on host
              stripRadiosInRoot(host);
            }
          });
        } else {
          // Fallback if for some reason radios are in light DOM
          stripRadiosInRoot(document);
        }
      }
      // Initial pass
      scanRechargeWidgets();
      // Keep cleaning every 250ms to catch re-renders and toggles
      setInterval(scanRechargeWidgets, 250);
});